import { Skeleton, Stack } from "@mui/material";
import { CHART_HEIGHT } from "src/components-mui/pages/detail/treemap-chart/constants";

const GAP = "2px";

interface ISkeletonBlockProps {
    height: number;
    width?: string;
    flex?: number;
}

const SkeletonBlock = ({ height, width, flex }: ISkeletonBlockProps) => <Skeleton variant="rectangular" sx={{ height, width, flex }} />;

interface ISkeletonColumnProps {
    flex: number;
    heights: number[];
}

const SkeletonColumn = ({ flex, heights }: ISkeletonColumnProps) => (
    <Stack sx={{ flex, gap: GAP }}>
        {heights.map((height, index) => (
            <SkeletonBlock key={index} height={height} width="100%" />
        ))}
    </Stack>
);

export const TreemapChartSkeleton = () => {
    return (
        <Stack sx={{ width: "100%", alignItems: "flex-start", height: CHART_HEIGHT, gap: GAP, overflow: "hidden" }}>
            <Stack direction="row" sx={{ width: "100%", gap: GAP }}>
                <SkeletonBlock height={300} flex={3} />
                <SkeletonBlock height={300} flex={2} />
                <SkeletonBlock height={300} flex={0.5} />
                <SkeletonColumn flex={0.5} heights={[150, 100, 46]} />
                <SkeletonColumn flex={0.5} heights={[150, 100, 46]} />
            </Stack>
            <Stack direction="row" sx={{ width: "100%", gap: GAP, alignItems: "flex-start" }}>
                <SkeletonColumn flex={3} heights={[300]} />
                <SkeletonColumn flex={2} heights={[100, 150]} />
                <SkeletonColumn flex={0.5} heights={[100, 150]} />
                <SkeletonColumn flex={1.5} heights={[80, 80, 90]} />
                <SkeletonColumn flex={1} heights={[80, 80, 90]} />
            </Stack>
        </Stack>
    );
};
